// 只保留项目中实际使用的函数
export function renderQuota(quota, digits = 2) {
  let quotaPerUnit = 500000;
  return "$" + (quota / quotaPerUnit).toFixed(digits);
}
